import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LivesearchService {
  constructor(
    private axios,
    private env
  ) {
  }

  public search = (keyword, input_id, type='address', mode='admin') => new Promise(async (resolve, reject) => {
    this.axios.get(``, {
      params: {
        t: type,
        mode: mode,
        id: input_id,
        q: keyword,
        site_id: this.env['site_id'],
      }
    })
      .then(res => {
        resolve(res.data);
      }).catch((error) => {
        reject({
          error: true,
          message: error
        });
      });
  })

}
